/**
 * Registre des templates inbasket.
 * Gère le chargement des templates et expose les helpers associés.
 */

import { TemplateInbasketEnum } from "@convex/schema";
import { defaultTemplate } from "./default";
import { rapideTemplate } from "./rapide";
import type { InbasketTemplateConfig } from "./types";

// Registre de tous les templates disponibles
const templateRegistry: Record<string, InbasketTemplateConfig> = {
  [TemplateInbasketEnum.DEFAULT]: defaultTemplate,
  [TemplateInbasketEnum.RAPIDE]: rapideTemplate,
  // Ajouter ici les futurs templates :
  // [TemplateInbasketEnum.TEMPLATE_A]: templateA,
};

/**
 * Configuration d'un template, par son identifiant.
 * Repli sur le template par défaut si l'identifiant est inconnu.
 */
export function getTemplate(templateId?: string): InbasketTemplateConfig {
  if (!templateId || !templateRegistry[templateId]) {
    return defaultTemplate;
  }
  return templateRegistry[templateId];
}

// Ré-exporte les types et le template par défaut
export { defaultTemplate } from "./default";
export { rapideTemplate } from "./rapide";
export type { InbasketTemplateConfig } from "./types";

